import ReCAPTCHA from 'react-google-recaptcha';
import { useEffect, forwardRef } from 'react';

const SandhillsReCAPTCHA = forwardRef((props, ref) => {


    useEffect(() => {
        if (window?.grecaptcha && ref && props.onCaptchaClosedBeforeCompletion && props.captchaOpen) {
            let overlay = [...document?.getElementsByTagName('iframe')]?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))?.parentNode?.parentNode;
            if (overlay && !(overlay.onclick && typeof overlay.onclick == "function")) {
                overlay.onclick = () => {
                    props.onCaptchaClosedBeforeCompletion?.();
                };
            }
        }
    }, [props.captchaOpen]);

    return (
        <>
        <label htmlFor="g-recaptcha-response" style={{ display: 'none' }}>Recaptcha</label>
        <ReCAPTCHA
            ref={ref}
            sitekey={props.sitekey}
            size={props.size || 'invisible'}
            badge={props.badge || 'inline'}
            onChange={props.onChange}
        />
        </>
        
    );
});

export default SandhillsReCAPTCHA;